// Module
var code = `<div class="HOA-cobrand-header-parent HOA-page-padding-negative-offset-margin-trl HOA-page-padding-top-viaPrevSiblingMarginBottom" *ngIf="!propertyManaged">
    <div class="HOA-cobrand-header">
        <div class="HOA-header-detail" tid="cobrandHeaderDetail">{{headerMessageValue}}</div>
        <div class="HOA-header-property" tid="cobrandHeaderProperty">{{property}}</div>
        <div class="HOA-header-management" tid="cobrandHeaderManagement">{{association}} - {{manager}}</div>
    </div>
</div>

<div class="HOA-cobrand-header-parent HOA-page-padding-negative-offset-margin-trl HOA-page-padding-top-viaPrevSiblingMarginBottom" *ngIf="propertyManaged">
    <div class="HOA-cobrand-header">
        <div class="HOA-header-detail" tid="cobrandHeaderDetail">{{headerMessageValue}}</div>
        <div class="HOA-header-property" tid="cobrandHeaderManager">{{manager}}</div>
        <div class="HOA-header-management" tid="cobrandHeaderAssociation">{{association}}</div>
    </div>
</div>`;
// Exports
module.exports = code;